import { ChartActionType } from "models/actionTypes/chartActionTypes";
import { ContextConstants } from "utils/constants";
import { ChartContextState } from "models/propTypes/chartProps";

export const ChartReducer = (state: ChartContextState, action: ChartActionType) => {
  switch (action.type) {
    case ContextConstants.ChartActions.SET_CHART_TYPE: {
      return { ...state, type: action.payload };
    }
    case ContextConstants.ChartActions.SET_CHART_FILTER: {
      return { ...state, filter: action.payload };
    }
    default:
      return state;
  }
};
